import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=e0d50020&scoped=true"
import script from "./tabla.js?vue&type=script&lang=js&external"
export * from "./tabla.js?vue&type=script&lang=js&external"
import style0 from "./tabla.scss?vue&type=style&index=0&id=e0d50020&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d50020",
  null
  
)

export default component.exports